import React, { FC } from 'react';

import { Icon } from 'common/components';
import { actionIcCheckCircle24px, navigationIcClose24px } from 'assets/media/icons';

import './MessageGuide.scss';

type MessageGuideProps = {
    message: string;
};

const MessageGuide: FC<MessageGuideProps> = ({ message }: MessageGuideProps) => {
    return (
        <div className="message-guide-container" dangerouslySetInnerHTML={{ __html: message }} />
    );
};

export default MessageGuide;
